<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
  <circle cx="15.047" cy="15.047" r="14.953" fill="var(--dt-surface-progressbar-progressbar-on-going, #FFFFFF)"
    style="stroke-width:1.0681" />
  <path fill="var(--dt-icon-episode-list-check-icon, #EC3654)"
    d="M13.235 21.641 6.75 15.602l2.343-2.475 3.976 3.704 7.706-8.472 2.475 2.343Z" style="stroke-width:.825001" />
</svg>